import type { Enums } from "../types";

export const unitArray: Enums<"unit">[] = [
	"percent",
	"number",
	"calendar-days",
	"weeks",
	"business-days",
	"work-days",
	"meters",
	"square-meters",
	"cubic-meters",
	"currency",
	"days",
] as const;

export const dayUnits =
	// : Enums<"unit">[]
	["weeks", "business-days", "work-days", "calendar-days"] as const;

export const sizeUnits =
	//: Enums<"unit">[]
	["millimeters", "centimeters", "meters", "kilometers"] as const;

export type SizeUnit = (typeof sizeUnits)[number];

export const weightUnits =
	//: Enums<"unit">[]
	["gram", "kilogram", "ton"] as const;

export type WeightUnit = (typeof weightUnits)[number];

/**
 * Why a stock movement happened, in the order a booking form should offer them: goods in first,
 * because that is the common hand-booked case, and `pick` last because the picking round writes
 * it for itself rather than anyone choosing it.
 */
export const transactionTypes =
	//: Enums<"transactionType">[]
	["restock", "return", "inventory", "correction", "pick"] as const;

export type TransactionType = (typeof transactionTypes)[number];

export type DayUnit = (typeof dayUnits)[number];
